<template>
    <div class="d-flex flex-column gap-3 flex-1-1">
        <v-card color="grey lighten-5" elevation="0" rounded>
            <v-card-text>
                <div class="d-flex align-center gap-2 mb-2">
                    <v-icon class="font-color-light font-weight-bold">mdi-fire</v-icon>
                    <span class="font-color-light font-weight-bold">{{ $t('consumed_in_period') }}</span>
                </div>
                <div class="text-center py-3">
                    <span class="font-36 font-color-normal">
                        {{ consumption && consumption.consumption > 0 ? displayToHumanNumberWithSpace(consumption.consumption) : 0 }}
                        {{ unit }}
                    </span>
                </div>
                <v-divider />
                <div class="d-flex justify-space-between pt-2">
                    <span class="font-color-light font-weight-bold font-12">{{ $t('average_by_day') }}</span>
                    <span class="font-color-normal font-weight-bold font-12">
                        {{
                            consumption && consumption.average_consumption > 0
                                ? displayToHumanNumberWithSpace(consumption.average_consumption)
                                : 0
                        }}
                        {{ unit }}/{{ $t('day_abbreviation') }}
                    </span>
                </div>
            </v-card-text>
        </v-card>

        <v-card color="grey lighten-5" elevation="0" rounded>
            <v-card-text>
                <div class="d-flex align-center gap-2 mb-2">
                    <v-icon class="font-color-light font-weight-bold">mdi-tanker-truck</v-icon>
                    <span class="font-color-light font-weight-bold">{{ $t('quantity_delivered_in_period') }}</span>
                </div>
                <div class="text-center py-3">
                    <span class="font-36 font-color-normal">
                        {{ consumption ? displayToHumanNumberWithSpace(consumption.filling) : 0 }} {{ unit }}
                    </span>
                </div>
                <v-divider />
                <div class="d-flex justify-space-between pt-2">
                    <span class="font-color-light font-weight-bold font-12">{{ $t('average_by_day') }}</span>
                    <span class="font-color-normal font-weight-bold font-12">
                        {{ consumption ? displayToHumanNumberWithSpace(consumption.average_filling) : 0 }} {{ unit }}/{{ $t('day_abbreviation') }}
                    </span>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import DisplayHuman from '@/mixin/displayHuman'

export default {
    name: 'ConsumptionVariationCardComponent',
    mixins: [DisplayHuman],
    props: {
        consumption: {
            type: Object,
            default: null,
        },
        unit: {
            type: String,
            required: true,
        },
    },
}
</script>
